import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<
    'primary' | 'secondary' | 'tertiary' | 'error' | 'warning' | 'success' | 'informative' | 'goGreen' | 'inherit'
  >
}>

export const Body2 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="body2" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
